import { Box, Popover, Tooltip, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { get, orderBy } from "lodash";
import { useStyles } from "../styles";
import UserProfileWidget from "../../../widgets/UserProfileWidget";
import { checkArrayLength } from "../../../../utils";

const CheckinAssignedUsers = (colProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (
      get(colProps, "dataItem.checkInType", "") !== "SKILLRATING" &&
      checkArrayLength(get(colProps, "dataItem.usercheckin.items", []) || [])
    ) {
      setUserList(
        (get(colProps, "dataItem.usercheckin.items", []) || []).map(
          (i) => i.user
        )
      );
    } else if (
      get(colProps, "dataItem.checkInType", "") === "SKILLRATING" &&
      checkArrayLength(get(colProps, "dataItem.allCheckinRatees", []) || [])
    ) {
      setUserList([...(get(colProps, "dataItem.allCheckinRatees", []) || [])]);
    }
  }, [checkArrayLength(get(colProps, "dataItem.usercheckin.items", []))]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const containerRef = useRef();

  const displayUserList = (res, key) => {
    return (
      <Tooltip title={get(res, "firstName", "")} key={key}>
        <Box
          display="flex"
          className={classes.coacheeList}
          key={key}
          alignItems="center"
        >
          <UserProfileWidget
            firstName={get(res, "firstName", "")}
            lastName={get(res, "lastName", "")}
            url={get(res, "profileImage.fileName", "")}
            status={get(res, "status", "")}
          />
          <Box width="80%" textAlign="left">
            <Typography variant="body2" noWrap="true">
              {`${get(res, "firstName", "")} ${get(res, "lastName", "")}`}
              <span className="font-12 f-light-gray">
                {`${get(res, "status", "") === "PENDING" ? " (Pending)" : ""}`}
              </span>
            </Typography>
          </Box>
        </Box>
      </Tooltip>
    );
  };

  return (
    <td>
      <Box
        data-testid="handleClick"
        inputProps={{ "data-testid": "handleClick" }}
        className={classes.coachInfo}
        aria-describedby={id}
        onClick={handleClick}
        display="flex"
        // flexDirection="column"
        alignItems="center"
      >
        <span className="cursor-pointer">
          {checkArrayLength(userList)} coachees
        </span>
      </Box>
      {checkArrayLength(userList) ? (
        <Popover
          data-testid="handleClose"
          container={containerRef.current}
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box>
            {orderBy(userList, "firstName").map((res, index) => {
              return displayUserList(res, index);
            })}
          </Box>
        </Popover>
      ) : null}
    </td>
  );
};

export default CheckinAssignedUsers;
